import { NavigateFunction } from "react-router-dom";
import { Action } from "redux";
import { putResolve, takeLatest } from "redux-saga/effects";

import { IInitialState } from "@/types/initialState.types";
import { MOVE_CANDIDATE_TO_LOBBY } from "@/constants/ActionTypes";
import { goToLobbyRoute } from "@/utils/switchRoute.utils";
import {
  handleRemoveAudioVideo,
  leaveUserFromCall,
  stopScreenShare,
} from "@/utils/zoom.utils";
import { call, select } from "./utils.saga";

interface IMoveToLobbyArgs extends Action {
  payload: {
    interviewSlug: string;
    navigate: NavigateFunction;
  };
}

function* moveToLobby({ payload }: IMoveToLobbyArgs) {
  const { navigate, interviewSlug } = payload;
  const { socket, client, stream } = yield* select((state: IInitialState) => ({
    socket: state.socket.socket,
    client: state.zoomClient.client,
    stream: state.zoomClient.stream,
  }));

  yield call(handleRemoveAudioVideo, stream, client);
  yield call(stopScreenShare, client, stream);
  yield call(leaveUserFromCall, client);

  socket?.disconnect();
  yield putResolve({
    type: `${MOVE_CANDIDATE_TO_LOBBY}_SUCCESS`,
  });

  goToLobbyRoute(navigate, interviewSlug, {
    replace: true,
    relative: undefined,
  });
}

export default function* loadMoveToLobbySaga() {
  yield takeLatest(MOVE_CANDIDATE_TO_LOBBY, moveToLobby);
}
